// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and basic styles */
.tooltip-container {
    position: relative;
    display: inline-block;
    z-index: 10000;
    /* Asegúrate de que este valor sea mayor que el del modal */
}



.tooltip-inner {
    padding: 12px;
    color: #fff;
    text-align: center;
    justify-content: center;
    background-color: #006699;
    border: none;
    width: auto;
    box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
}

.TooltipContent {
    border-radius: 4px;
    /* padding: 10px 15px; */
    font-size: 14px;
    /* Ajusta el tamaño de la fuente según sea necesario */
    line-height: 1.5;
    color: #fff;
    /* box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px; */
    background-color: #006699;
    /* Asegúrate de que el color de fondo coincide */
    -webkit-user-select: none;
            user-select: none;
    animation-duration: 400ms;
    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
    will-change: transform, opacity;
    white-space: wrap;
    /* Para evitar que el texto se envuelva */
    z-index: 10000;
    /* overflow: visible; */
}

.TooltipContent[data-state='delayed-open'][data-side='top'] {
    animation-name: slideDownAndFade;
}

.TooltipContent[data-state='delayed-open'][data-side='right'] {
    animation-name: slideLeftAndFade;
}

.TooltipContent[data-state='delayed-open'][data-side='bottom'] {
    animation-name: slideUpAndFade;
}

.TooltipContent[data-state='delayed-open'][data-side='left'] {
    animation-name: slideRightAndFade;
}

.tooltip-arrow {
    fill: #006699;
}

@keyframes slideUpAndFade {
    from {
        opacity: 0;
        transform: translateY(2px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes slideRightAndFade {
    from {
        opacity: 0;
        transform: translateX(-2px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes slideDownAndFade {
    from {
        opacity: 0;
        transform: translateY(-2px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes slideLeftAndFade {
    from {
        opacity: 0;
        transform: translateX(2px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.tooltip-trigger {
    cursor: help;
    /* Opcional, si deseas que el cursor cambie al pasar sobre el ícono */
    display: inline-flex;
    /* Asegurarse de que el trigger sea un elemento inline-flex */
    align-items: center;
    /* Centrando el ícono */
    justify-content: center;
    /* Centrando el ícono */
}

@media (max-width: 768px) {
    .tooltip-container {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Css/stylesRadix.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,2DAA2D;AAC/D;;;;AAIA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,gGAAgG;AACpG;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,sDAAsD;IACtD,gBAAgB;IAChB,WAAW;IACX,sGAAsG;IACtG,yBAAyB;IACzB,gDAAgD;IAChD,yBAAiB;YAAjB,iBAAiB;IACjB,yBAAyB;IACzB,wDAAwD;IACxD,+BAA+B;IAC/B,iBAAiB;IACjB,yCAAyC;IACzC,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,YAAY;IACZ,qEAAqE;IACrE,oBAAoB;IACpB,6DAA6D;IAC7D,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* Reset and basic styles */\n.tooltip-container {\n    position: relative;\n    display: inline-block;\n    z-index: 10000;\n    /* Asegúrate de que este valor sea mayor que el del modal */\n}\n\n\n\n.tooltip-inner {\n    padding: 12px;\n    color: #fff;\n    text-align: center;\n    justify-content: center;\n    background-color: #006699;\n    border: none;\n    width: auto;\n    box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px;\n}\n\n.TooltipContent {\n    border-radius: 4px;\n    /* padding: 10px 15px; */\n    font-size: 14px;\n    /* Ajusta el tamaño de la fuente según sea necesario */\n    line-height: 1.5;\n    color: #fff;\n    /* box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px; */\n    background-color: #006699;\n    /* Asegúrate de que el color de fondo coincide */\n    user-select: none;\n    animation-duration: 400ms;\n    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);\n    will-change: transform, opacity;\n    white-space: wrap;\n    /* Para evitar que el texto se envuelva */\n    z-index: 10000;\n    /* overflow: visible; */\n}\n\n.TooltipContent[data-state='delayed-open'][data-side='top'] {\n    animation-name: slideDownAndFade;\n}\n\n.TooltipContent[data-state='delayed-open'][data-side='right'] {\n    animation-name: slideLeftAndFade;\n}\n\n.TooltipContent[data-state='delayed-open'][data-side='bottom'] {\n    animation-name: slideUpAndFade;\n}\n\n.TooltipContent[data-state='delayed-open'][data-side='left'] {\n    animation-name: slideRightAndFade;\n}\n\n.tooltip-arrow {\n    fill: #006699;\n}\n\n@keyframes slideUpAndFade {\n    from {\n        opacity: 0;\n        transform: translateY(2px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes slideRightAndFade {\n    from {\n        opacity: 0;\n        transform: translateX(-2px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n@keyframes slideDownAndFade {\n    from {\n        opacity: 0;\n        transform: translateY(-2px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes slideLeftAndFade {\n    from {\n        opacity: 0;\n        transform: translateX(2px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n.tooltip-trigger {\n    cursor: help;\n    /* Opcional, si deseas que el cursor cambie al pasar sobre el ícono */\n    display: inline-flex;\n    /* Asegurarse de que el trigger sea un elemento inline-flex */\n    align-items: center;\n    /* Centrando el ícono */\n    justify-content: center;\n    /* Centrando el ícono */\n}\n\n@media (max-width: 768px) {\n    .tooltip-container {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
